import { withIcon } from '@optimizely/axiom-icons';

export const IconFolderBookmarkRegular = withIcon(
  {
    icon: [
      20,
      16,
      [],
      '',
      'M9.84375 4L8.5 2.65625C8.40625 2.5625 8.28125 2.5 8.15625 2.5H4C3.71875 2.5 3.5 2.75 3.5 3V13C3.5 13.2812 3.71875 13.5 4 13.5H16C16.25 13.5 16.5 13.2812 16.5 13V5C16.5 4.75 16.25 4.5 16 4.5H15V9.5C15 9.6875 14.875 9.875 14.7188 9.96875C14.5312 10.0312 14.3438 10.0312 14.1875 9.90625L12.5 8.625L10.7812 9.90625C10.625 10.0312 10.4375 10.0312 10.25 9.96875C10.0938 9.875 10 9.71875 10 9.5V4.125C9.9375 4.09375 9.90625 4.03125 9.84375 4ZM10.9062 2.9375C10.9688 3 11.0312 3 11.0938 3H16C17.0938 3 18 3.90625 18 5V13C18 14.125 17.0938 15 16 15H4C2.875 15 2 14.125 2 13V3C2 1.90625 2.875 1 4 1H8.15625C8.6875 1 9.1875 1.21875 9.5625 1.59375L10.9062 2.9375Z',
    ],
    iconName: 'folder-bookmark-regular',
    prefix: 'ax',
  },
  'IconFolderBookmarkRegular'
);
